import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryContants } from "../../../constant";
import { changePassword } from "../../../apis/account/account";
import { getRockstarOTP } from "../../../apis/game/game";

export const useChangePasswordMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: changePassword,
    onSuccess: () => {
      queryClient.invalidateQueries(queryContants.GET_ME);
    },
  });
};

export const useGetRockstarOTP = () => {
  return useMutation({
    mutationFn: (email) => getRockstarOTP(email),
    // onSuccess: () => {
    //   queryClient.invalidateQueries(queryContants.GET_ME);
    // },
  });
};
